module.exports =
  MANDATORY_SUBSCRIPTION: 'cfp4770;mandatory_subscription27'
  APP_OFFER: 'cfp3864;app_offer'
  NO_APP_OFFER: 'cfp3864;no_app_offer'